import XLSX from 'xlsx';
import helpers from './helpers';

export default {
  methods: {
    exportXLSPresupuestoInterno (presupuesto, ordenes) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Presupuesto",
        Subject: "Presupuesto",
        Author: "SGC",
        CreatedDate: new Date()
      };
    
      // let presupuestoNumero = presupuesto.numero;
      let presupuestoNumero = presupuesto.presupuestoNumero;
      let cliente = presupuesto.cliente;
      let accion = presupuesto.accion;
      let feeAgencia = presupuesto.feeAgencia;
      let feeAgenciaPremios = presupuesto.feeAgenciaPremios;
      let discriminarFee = presupuesto.discriminarFee;
      let cotizacion = presupuesto.cotizacion;
      let importeFee = presupuesto.importeFee;
      let importeFeePremios = presupuesto.importeFeePremios;
      let importeNeto = presupuesto.importeNeto;
      let importeImpuestos = presupuesto.importeImpuestos;
      let importeTotal = presupuesto.importeTotal;

      let data = [
        ['Nro.' , presupuestoNumero],
        ['Cliente' , cliente],
        ['Accion' , accion],
        [''],
        [
          'Rubro', 
          'Titulo',
          'Cantidad', 
          'Costo Estimado', 
          'Costo Interno', 
          'Pje Rentabilidad', 
          'Cotizacion', 
          'Importe Fee', 
          // 'Importe Neto', 
          // 'Importe Impuestos', 
          // 'Subtotal' 
        ],
      ];

      ordenes.forEach(orden => {
        let ordenArray = [
          orden.rubroTrabajo.trim(),
          orden.titulo.trim(),
          orden.cantidad, 
          orden.costoEstimado,
          orden.costoInterno,
          orden.pjeRentabilidad,
          orden.cotizacion,
          orden.importeFeeAgencia,
          // orden.importeNeto,
          // orden.importeImpuestos,
          // orden.importeTotal
        ];
        data.push(ordenArray);

        if (orden.descripcion) {
          if (orden.descripcion != '') {
            data.push([orden.descripcion]);
          }
        }
      
      });

      /* Totales */
      data.push(['']);
      if (Boolean(discriminarFee) == true) {
        data.push([ 'Subtotal', cotizacion, '']);
        data.push([ 'Fee Agencia', importeFee, '' ]);
        if (importeFeePremios != 0) {
          data.push([ 'Fee Rubros Diferenciados', importeFeePremios, '' ]);
        }
      }
      data.push([ 'Total (Iva no incl.)', importeNeto, '' ]);
      /*
      data.push([ 'Neto', importeNeto, '' ]);
      data.push([ 'Impuestos', importeImpuestos, '' ]);
      data.push([ 'Total', importeTotal, '' ]);
      */

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Presupuesto");

      let xlsName = 'presupuesto_'; 
      xlsName = xlsName.concat(presupuesto.presupuestoNumero.toString().trim());
      xlsName = xlsName.concat('.xlsx');
      XLSX.writeFile(wb, xlsName);

      return;
    },
    exportXLSRubros (rubros) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Rubros de Trabajo",
        Subject: "Rubros de Trabajo",
        Author: "SGC",
        CreatedDate: new Date()
      };
    
      let data = [
        ['Codigo', 'Nombre' , 'Descripcion', 'PjeMargenMinimo', 'Diferenciado'],
      ];

      for(let key in rubros) {
        const rubro = rubros[key];
        let rubroArray = [
            rubro.id,
            rubro.nombre,
            rubro.descripcion,
            rubro.pjeMargenMinimo,
            rubro.premios
          ];
        data.push(rubroArray);
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Rubros");

      let xlsName = 'rubros.xlsx'; 
      XLSX.writeFile(wb, xlsName);

      return;
    },
    exportXLSLibroBanco (params) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Libro Banco",
        Subject: "Libro Banco",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];
      
      if ((/true/i).test(params.showSaldo)) {
        data.push([
          'Fecha Cred./Deb.', 
          'Tipo de Movimiento' , 
          'Numero', 
          'Débito', 
          'Crédito',
          'Saldo',
          'Conciliado',
          'Observaciones',
          'Referencia'
        ]);
      } else {
        data.push([
          'Fecha Cred./Deb.', 
          'Tipo de Movimiento' , 
          'Numero', 
          'Débito', 
          'Crédito',
          'Conciliado',
          'Observaciones',
          'Referencia'
        ]);
      }

      params.libroBanco.forEach(movimiento => {
        if ((/true/i).test(params.showSaldo)) {
          // movimiento.acumulaSaldo ?  movimiento.saldoAcumulado : '',
          data.push([
            this.$options.filters.fecha(movimiento.fechaCreditoDebito),
            movimiento.bancoMovimientoTipo, 
            movimiento.numero,
            movimiento.haber,
            movimiento.debe,
            movimiento.saldoAcumulado,
            (movimiento.conciliado ? 'Si' : 'No'),
            movimiento.observaciones,
            movimiento.referencia
          ]);
        } else {
          data.push([
            this.$options.filters.fecha(movimiento.fechaCreditoDebito),
            movimiento.bancoMovimientoTipo, 
            movimiento.numero,
            movimiento.haber,
            movimiento.debe,
            (movimiento.conciliado ? 'Si' : 'No'),
            movimiento.observaciones,
            movimiento.referencia
          ]);
        }
      });

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Libro Banco");

      let xlsName = 'libro-banco.xlsx'; 
      XLSX.writeFile(wb, xlsName);

      return;
    },

    exportXLSHolistorVentas (ventas) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Ventas",
        Subject: "Ventas",
        Author: "SGC",
        CreatedDate: new Date()
      };
    
      let data = [
        [
          'Fecha', 
          'Cpbte' , 
          'Tipo', 
          'Suc.', 
          'Numero',
          'Cliente',
          'Tipo Doc.',
          'CUIT',
          'Domicilio',
          'CP',
          'Pcia',
          'Cond.Fiscal',
          'Cod.Neto',
          'Neto Gravado',
          'Alic.',
          'Liquidado',
          'IVA Debito',
          'Cód. NG/EX',
          'Conceptos NG/EX',
          'Cód. P/R',
          'Perc./Ret.',
          'Pcia P/R', 
          'Total'
        ],
      ];
      
      ventas.forEach(venta => {
        data.push([
          this.$options.filters.fecha(venta.fechaComprobante),
          venta.comprobante,
          venta.tipo,
          venta.sucursal,
          venta.numero,
          venta.cliente,
          venta.tipoDocumento,
          venta.numeroDocumento,
          venta.domicilio,
          venta.codigoPostal,
          venta.provincia,
          venta.condicionFiscal,
          '',
          venta.netoGravado,
          venta.pjeAlicuota,
          venta.ivaInscripto,
          venta.ivaInscripto,
          '',
          '',
          '',
          '',
          '',
          venta.total
        ]);
      });

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Ventas");

      let xlsName = 'holistor-ventas.xlsx'; 
      XLSX.writeFile(wb, xlsName);

      return;
    },

    exportXLSResumenDeudaProveedores (cuentaCorrienteProveedores) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Deuda",
        Subject: "DeudaProveedores",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let proveedorId = 0;
      let saldoAcumuladoPesos = 0;
      let saldoAcumuladoDolares = 0;

      let data = [ [] ];
      
      if (cuentaCorrienteProveedores.length != 0) {
        cuentaCorrienteProveedores.forEach(cuentaCorriente => {
          // console.log(cuentaCorriente);

          if (proveedorId != parseInt(cuentaCorriente.proveedorId)) {
            if (proveedorId != 0) {
              data.push([]);
              /* Subtotales */
              data.push([
                '',
                '',
                '',
                'Saldo Final',
                '',
                saldoAcumuladoPesos,
                '',
                saldoAcumuladoDolares
              ]);
              data.push([]);
            }

            /* Cabecera */
            proveedorId = parseInt(cuentaCorriente.proveedorId);
            data.push([ 'Proveedor', cuentaCorriente.proveedor.trim()]);
            data.push([]);
            data.push([
              'Fecha Comprobante',
              'Comprobante',
              'Numero',
              'Vencimiento',
              'Importe - $',
              'Saldo - $',
              'Importe - usd',
              'Saldo - usd',
            ]);
            
            saldoAcumuladoPesos = 0;
            saldoAcumuladoDolares = 0;
          }

          data.push([
            this.$options.filters.fecha(cuentaCorriente.fechaComprobante),
            cuentaCorriente.comprobanteTipo,
            cuentaCorriente.comprobanteNumero,
            this.$options.filters.fecha(cuentaCorriente.fechaVencimiento),
            cuentaCorriente.importePesos,
            cuentaCorriente.saldoPesos,
            cuentaCorriente.importeDolares,
            cuentaCorriente.saldoDolares,
          ]);

          saldoAcumuladoPesos += cuentaCorriente.saldoPesos;
          saldoAcumuladoDolares += cuentaCorriente.saldoDolares;
        });

        data.push([]);
        /* Subtotales (ultimo grupo) */
        data.push([
          '',
          '',
          '',
          'Saldo Final',
          '',
          saldoAcumuladoPesos,
          '',
          saldoAcumuladoDolares
        ]);
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "DeudaProveedores");
      XLSX.writeFile(wb, "DeudaProveedores.xlsx");

      return;
    },
    
    exportXLSResumenPlazosProveedores (comprobantes) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Plazos",
        Subject: "PlazosProveedores",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [
        'Proveedor',
        'Fecha Comprobante',
        'Comprobante',
        'Numero',
        'Vencimiento',
        'Moneda',
        'Importe Comp',
        'Nro Pago',
        'Fecha Pago',
        'Importe Pago',
        'Plazo Comprobante',
        'Plazo Promedio Documentos',
        'Plazo Pago'
      ] ];

      if (comprobantes.length != 0) {
        comprobantes.forEach(comprobante => {
          data.push([
            comprobante.proveedor,
            this.$options.filters.fecha(comprobante.fechaComprobante),
            comprobante.comprobanteTipo,
            comprobante.comprobanteNumero,
            this.$options.filters.fecha(comprobante.fechaVencimiento),
            comprobante.moneda,
            comprobante.importe,
            // comprobante.pagoId,
            comprobante.numeroPago,
            this.$options.filters.fecha(comprobante.fechaPago),
            comprobante.importePago,
            comprobante.plazoComprobante,
            comprobante.plazoPromedioDocumentos,
            comprobante.plazoPago
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "PlazosProveedores");
      XLSX.writeFile(wb, "PlazosProveedores.xlsx");

      return;
    },

    exportXLSResumenDeudaClientes (cuentaCorrienteClientes) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Deuda",
        Subject: "DeudaClientes",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [
        'Cliente',
        'Fecha Comprobante',
        'Comprobante',
        'Numero',
        'Vencimiento',
        'Importe - $',
        'Saldo - $',
        'Importe - usd',
        'Saldo - usd',
      ] ];
      
      if (cuentaCorrienteClientes.length != 0) {
        cuentaCorrienteClientes.forEach(cuentaCorriente => {
          data.push([
            cuentaCorriente.cliente,
            this.$options.filters.fecha(cuentaCorriente.fechaComprobante),
            cuentaCorriente.comprobanteTipo,
            cuentaCorriente.comprobanteNumero,
            this.$options.filters.fecha(cuentaCorriente.fechaVencimiento),
            cuentaCorriente.importePesos,
            cuentaCorriente.saldoPesos,
            cuentaCorriente.importeDolares,
            cuentaCorriente.saldoDolares
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "DeudaClientes");
      XLSX.writeFile(wb, "DeudaClientes.xlsx");

      return;
    },

    exportXLSResumenDeudaClientesAgrupado (cuentaCorrienteClientes) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Deuda",
        Subject: "DeudaClientes",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let clienteId = 0;
      let saldoAcumuladoPesos = 0;
      let saldoAcumuladoDolares = 0;

      let data = [ [] ];
      
      if (cuentaCorrienteClientes.length != 0) {
        cuentaCorrienteClientes.forEach(cuentaCorriente => {
          // console.log(cuentaCorriente);

          if (clienteId != parseInt(cuentaCorriente.clienteId)) {
            if (clienteId != 0) {
              data.push([]);
              /* Subtotales */
              data.push([
                '',
                '',
                '',
                'Saldo Final',
                '',
                saldoAcumuladoPesos,
                '',
                saldoAcumuladoDolares
              ]);
              data.push([]);
            }

            /* Cabecera */
            clienteId = parseInt(cuentaCorriente.clienteId);
            data.push([ 'Cliente', cuentaCorriente.cliente.trim()]);
            data.push([]);
            data.push([
              'Fecha Comprobante',
              'Comprobante',
              'Numero',
              'Vencimiento',
              'Importe - $',
              'Saldo - $',
              'Importe - usd',
              'Saldo - usd',
            ]);

            saldoAcumuladoPesos = 0;
            saldoAcumuladoDolares = 0;
          }

          data.push([
            this.$options.filters.fecha(cuentaCorriente.fechaComprobante),
            cuentaCorriente.comprobanteTipo,
            cuentaCorriente.comprobanteNumero,
            this.$options.filters.fecha(cuentaCorriente.fechaVencimiento),
            cuentaCorriente.importePesos,
            cuentaCorriente.saldoPesos,
            cuentaCorriente.importeDolares,
            cuentaCorriente.saldoDolares
          ]);
          saldoAcumuladoPesos += cuentaCorriente.saldoPesos;
          saldoAcumuladoDolares += cuentaCorriente.saldoDolares;
        });

        data.push([]);
        /* Subtotales (ultimo grupo) */
        data.push([
          '',
          '',
          '',
          'Saldo Final',
          '',
          saldoAcumuladoPesos,
          '',
          saldoAcumuladoDolares,
        ]);
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "DeudaClientes");
      XLSX.writeFile(wb, "DeudaClientes.xlsx");

      return;
    },

    exportXLSResumenPlazosClientes (comprobantes) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Plazos",
        Subject: "PlazosClientes",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [
        'Cliente',
        'Fecha Comprobante',
        'Comprobante',
        'Numero',
        'Vencimiento',
        'Moneda',
        'Importe Comp',
        'Nro Cobro',
        'Fecha Cobro',
        'Importe Cobro',
        'Plazo Comprobante',
        'Plazo Promedio Documentos',
        'Plazo Cobro'
      ] ];

      if (comprobantes.length != 0) {
        comprobantes.forEach(comprobante => {
          data.push([
            comprobante.cliente,
            this.$options.filters.fecha(comprobante.fechaComprobante),
            comprobante.comprobanteTipo,
            comprobante.comprobanteNumero,
            this.$options.filters.fecha(comprobante.fechaVencimiento),
            comprobante.moneda,
            comprobante.importe,
            comprobante.cobroId,
            this.$options.filters.fecha(comprobante.fechaCobro),
            comprobante.importeCobro,
            comprobante.plazoComprobante,
            comprobante.plazoPromedioDocumentos,
            comprobante.plazoCobro
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "PlazosClientes");
      XLSX.writeFile(wb, "PlazosClientes.xlsx");

      return;
    },

    exportXLSRptPresupuestos (presupuestosInternos) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Presupuestos Internos",
        Subject: "PresupuestosInternos",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      data.push([
        'Nro.Presupuesto',
        'Fecha de Registro',
        'Fecha de Confirmación',
        'Fecha de Entrega',
        'Fecha de Cierre Estimada',
        'Fecha de Cierre',
        'Cliente',
        'Accion',
        'Contacto',
        'Nro.PO',
        'Tipo Presupuesto',
        'Prioridad',
        'Costo Estimado',
        'Costo Real',
        'Cotizacion',
        'Moneda',
        'Cotizacion USD',
        'Cotizacion Total',
        'Pje Financiación',
        'Importe Financiación',
        'Fee sobre Financiación',
        'Fee Agencia',
        'Importe Fee',
        'Fee Premios',
        'Importe Fee Premios',
        'Total Presupuestado',
        'Pje Certificado',
        'Importe Certificado',
        'Pje Facturado',
        'Importe Facturado',
        'Pje Rentabilidad Estimado',
        'Pje Rentabilidad Real',
        'Certificados',
        'Coordinador',
        'Usuarios Asignados'
      ]);

      if (presupuestosInternos.length != 0) {
        presupuestosInternos.forEach(presupuestoInterno => {
          let cotizacionTotal = presupuestoInterno.cotizacionTotal;
          let importeFinanciacion = presupuestoInterno.importeFinanciacion;
          let importeFee = presupuestoInterno.importeFee;
          let importeFeePremios = presupuestoInterno.importeFeePremios;
          let importeNeto = presupuestoInterno.importeNeto;
          let importeNetoCertificado = presupuestoInterno.importeNetoCertificado;

          if (presupuestoInterno.monedaId != 101) {
            cotizacionTotal = helpers.methods.roundToTwo(parseFloat(presupuestoInterno.cotizacionTotal) * parseFloat(presupuestoInterno.monedaCotizacion));
            importeFinanciacion = helpers.methods.roundToTwo(parseFloat(presupuestoInterno.importeFinanciacion) * parseFloat(presupuestoInterno.monedaCotizacion));
            importeFee = helpers.methods.roundToTwo(parseFloat(presupuestoInterno.importeFee) * parseFloat(presupuestoInterno.monedaCotizacion));
            importeFeePremios = helpers.methods.roundToTwo(parseFloat(presupuestoInterno.importeFeePremios) * parseFloat(presupuestoInterno.monedaCotizacion));
            importeNeto = helpers.methods.roundToTwo(parseFloat(presupuestoInterno.importeNeto) * parseFloat(presupuestoInterno.monedaCotizacion));
            importeNetoCertificado = helpers.methods.roundToTwo(parseFloat(presupuestoInterno.importeNetoCertificado) * parseFloat(presupuestoInterno.monedaCotizacion));
          }

          data.push([
            presupuestoInterno.presupuestoNumero,
            // presupuestoInterno.id,
            this.$options.filters.fecha(presupuestoInterno.fechaRegistro),
            this.$options.filters.fecha(presupuestoInterno.fechaConfirmacion),
            this.$options.filters.fecha(presupuestoInterno.fechaEntrega),
            this.$options.filters.fecha(presupuestoInterno.fechaCierreEstimado),
            this.$options.filters.fecha(presupuestoInterno.fechaCierre),
            presupuestoInterno.cliente,
            presupuestoInterno.accion,
            presupuestoInterno.clienteContacto,
            presupuestoInterno.numeroOrdenCompra,
            presupuestoInterno.tipoPresupuesto,
            presupuestoInterno.prioridad,

            presupuestoInterno.costoTotal,
            presupuestoInterno.costoRealTotal,

            presupuestoInterno.cotizacionTotal,
            presupuestoInterno.moneda,
            presupuestoInterno.monedaId == 101? '' : presupuestoInterno.monedaCotizacion,
            cotizacionTotal,

            presupuestoInterno.pjeFinanciacion,
            importeFinanciacion,
            presupuestoInterno.feeSobreFinanciacion? 'Si' : 'No',

            presupuestoInterno.feeAgencia,
            importeFee,

            presupuestoInterno.feeAgenciaPremios,
            importeFeePremios,

            importeNeto,
            presupuestoInterno.pjeCertificado,
            importeNetoCertificado,
            presupuestoInterno.pjeFacturado,
            presupuestoInterno.importeNetoFacturado,

            presupuestoInterno.pjeRentabilidad,
            presupuestoInterno.pjeRentabilidadReal,

            presupuestoInterno.certificados,

            presupuestoInterno.usuarioCoordinador,
            presupuestoInterno.usuarios
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "PresupuestosInternos");
      XLSX.writeFile(wb, "PresupuestosInternos.xlsx");

      return;
    },

    exportXLSRptPresupuestosPremios (presupuestosInternos) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Presupuestos Internos - Premios",
        Subject: "PresupuestosInternosPremios",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      data.push([
        'Nro.Presupuesto',
        'Fecha de Registro',
        'Cliente',
        'Accion',
        'Importe Transferido',
      ]);

      if (presupuestosInternos.length != 0) {
        presupuestosInternos.forEach(presupuestoInterno => {
          data.push([
            // presupuestoInterno.id,
            presupuestoInterno.presupuestoNumero,
            this.$options.filters.fecha(presupuestoInterno.fechaRegistro),
            presupuestoInterno.cliente,
            presupuestoInterno.accion,
            presupuestoInterno.importe
            // this.$options.filters.moneda(presupuestoInterno.importe)
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "PresupuestosInternosPremios");
      XLSX.writeFile(wb, "PresupuestosInternosPremios.xlsx");

      return;
    },

    exportXLSPlanCuentas (planCuentas) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Plan de Cuentas",
        Subject: "PlanCuentas",
        Author: 'SGC',
        CreatedDate: new Date()
      };
    
      let data = [
        ['' , '', ''],
      ];

      planCuentas.forEach(cuenta => {
        data.push([ `${cuenta.codigo.trim()} - ${cuenta.nombre.trim()}`  ]);
        
        if (cuenta.rubros) {
          cuenta.rubros.forEach(rubro => {
            data.push(['', `${cuenta.codigo.trim() + rubro.codigo.trim()} - ${rubro.nombre.trim()}`  ]);
            
            if (rubro.subrubros) {
              rubro.subrubros.forEach(subrubro => {
                data.push(['', '', `${cuenta.codigo.trim() + rubro.codigo.trim() + subrubro.codigo.trim()} - ${subrubro.nombre.trim()}`  ]);
              });
            }
          });
        }
      });

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "PlanCuentas");
      XLSX.writeFile(wb, "plancuentas.xlsx");

      return;
    },
    exportXLSComisionesVendedores (presupuestos) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Comisiones",
        Subject: "ComisionesVendedores",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [];

      let firstItem = true;

      presupuestos.forEach(presupuesto => {
        if (!firstItem) {
          data.push([]);
          data.push([]);  
        } else {
          firstItem = false;
        }

        data.push([ 'Nro. Presupuesto:', , presupuesto.presupuestoNumero ]);
        data.push([ 'Cliente:', , presupuesto.cliente ]);
        data.push([ 'Accion:', , presupuesto.accion ]);
        data.push([ 'Vendedor:', , presupuesto.vendedor ]);
        data.push([ 'Pje.Comision:', , presupuesto.pjeComision ]);

        data.push([]);

        /* Ventas */
        data.push([
          'Fecha de Venta',
          'Comprobante',
          'Nro.Comprobante',
          'Monto Venta',
          'Comisión'
        ]);

        if (presupuesto.ventas) {
          let totalVentas = 0;
          let totalComisiones = 0;

          presupuesto.ventas.forEach(venta => {
            totalVentas += parseFloat(venta.montoVenta);
            totalComisiones += parseFloat(venta.montoComision);

            data.push([
              this.$options.filters.fecha(venta.fechaVenta),
              venta.comprobanteVenta,
              venta.numeroVenta,
              venta.montoVenta,
              venta.montoComision
            ]);
          });

          data.push([ , , , totalVentas, totalComisiones ]);
        }

        data.push([]);
        /* Totales */
        data.push([ 'Total del Presupuesto:', , presupuesto.totalPresupuesto ]);
        data.push([ 'Total de Ventas:', , presupuesto.totalVentas ]);
        data.push([ 'Total de Comisiones:', , presupuesto.totalComision ]);
        data.push([ 'Total de Compras:', , presupuesto.totalCompras ]);
        data.push([ 'Saldo:', , presupuesto.totalComision - presupuesto.totalCompras ]);
      })
  
      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "ResumenComisiones");
      XLSX.writeFile(wb, "ResumenComisiones.xlsx");

      return;
    },
    exportXLSFlujoFondos (flujoFondos, flujoFondosFields) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Flujo de Fondos",
        Subject: "FlujoFondos",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      let cols = [];
      flujoFondosFields.forEach(col => {
        cols.push(col.label)
      });
      data.push(cols);
      
      flujoFondos.forEach(row => {
        console.log(row);
        cols = [];
        Object.values(row).forEach(col => {
          console.log(col);
          cols.push(col)
        })
        data.push(cols);
      });

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "FlujoFondos");
      XLSX.writeFile(wb, "FlujoFondos.xlsx");

      return;
    },

    exportXLS (title, fileName, list, format) {
      // let empresa = this.$store.getters['user/empresa'];

      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: title,
        Subject: title,
        Author: 'SGC',
        CreatedDate: new Date()
      };
    
      let data = [];
      let row = [];

      format.forEach(field => {
        row.push(field.titulo);
      });
      data.push(row);

      list.forEach(item => {
        row = [];
        format.forEach(field => {
          if (field.formato) {
            switch (field.formato.trim()) {
              case 'fecha':
                row.push(this.$options.filters.fecha(item[field.nombre]));
                break;

              case 'fechaHora':
                row.push(this.$options.filters.fechaHora(item[field.nombre]));
                break;

              case 'periodo':
                row.push(this.$options.filters.periodo(item[field.nombre]));
                break;
                  
              case 'bool':
                let valor = 'No';
                if ((/true/i).test(item[field.nombre])) {
                  valor = 'Si';
                }
                row.push(valor);
                break;
              
              case 'importe':
                row.push(this.$options.filters.numero(item[field.nombre], 2, true));
                break;

              case 'numero':
                row.push(this.$options.filters.numero(item[field.nombre], 2, false));
                break;

              default:
                row.push(item[field.nombre]);
                break;
            }
          } else {
            row.push(item[field.nombre]);
          }
        });
  
        data.push(row);
      });

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, title);
      XLSX.writeFile(wb, fileName.trim() + '.xlsx');

      return;
    },

  }
}
